module.exports = __webpack_public_path__ + "static/img/13-13.c28913dd.jpeg";